/**
 * Create the store with dynamic reducers
 */

import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { applyMiddleware, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import createReducer from './reducers';

const reduxDevToolsOptions = {
  name: 'Search V2',
  actionsDenylist: [
    // update_checkout_timer fires twice a second in checkout, adding unneeded noise
    'data/UPDATE_CHECKOUT_TIMER',
    // rehydrate fires when the app is opened with ~10MB of data, causing dev tools to slow down
    'persist/REHYDRATE',
  ],
  // Enabling trace can cause performance issues in dev tools, enable it temporarily if needed
  // but don't commit it to the codebase
  // trace: true,
};

export default function configureStore(initialState = {}, history) {
  // Set up Redux Dev Tools in dev env
  const compose = composeWithDevToolsDevelopmentOnly(reduxDevToolsOptions);

  const sagaMiddleware = createSagaMiddleware({});
  const routerMiddleware = createRouterMiddleware(history);

  // Create the store with two middlewares
  const enhancers = compose(applyMiddleware(
    // 1. sagaMiddleware: Makes redux-sagas work
    sagaMiddleware,
    // 2. routerMiddleware: Syncs the location/URL path to the state
    routerMiddleware,
  ));

  const store = createStore(createReducer(), initialState, enhancers);

  const persistor = persistStore(store);

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return { store, persistor };
}
